module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Align-center-9a650b0d27849c4f9774b264bb59a763.svg";